import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatProgressBarModule,MatInputModule, MatCheckboxModule, MatDatepickerModule,  MatButtonModule, MatTooltipModule, MatSelectModule, MatIconModule,MatRadioModule, MatToolbarModule, MatProgressSpinnerModule, MatCardModule, MatNativeDateModule} from '@angular/material';
import { HeaderComponent } from '../common/header/header.component';
import { FooterComponent } from '../common/footer/footer.component';
import { InnerHeaderComponent } from '../common/inner-header/inner-header.component';
import { CalendarComponent } from '../common/calendar/calendar.component';
import { GiftcardComponent } from '../common/giftcard/giftcard.component';
import { CartComponent } from '../common/cart/cart.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { InnerFooterComponent } from '../common/inner-footer/inner-footer.component';
import { ToastComponent } from '../common/toast/toast.component';
import { FiltersPipe } from '../shared/filters.pipe';
@NgModule({
  declarations: [CartComponent,HeaderComponent,FooterComponent,CalendarComponent,GiftcardComponent,InnerFooterComponent,InnerHeaderComponent,ToastComponent,FiltersPipe],
  // declarations: [InnerFooterComponent,ToastComponent,FiltersPipe],
  imports: [
    CommonModule,
    MatInputModule, 
    MatCheckboxModule, 
    MatDatepickerModule,  
    MatButtonModule, 
    MatSelectModule, 
    MatIconModule, 
    MatToolbarModule, 
    MatProgressSpinnerModule, 
    MatCardModule, 
    MatNativeDateModule,
    FormsModule,
    MatTooltipModule,
    ReactiveFormsModule,
    MatRadioModule,
    NgbModule
  ],
  exports :[
  	MatInputModule, 
    MatCheckboxModule, 
    MatDatepickerModule,  
    MatRadioModule,
    MatButtonModule, 
    MatSelectModule, 
    MatIconModule, 
    MatToolbarModule, 
    MatProgressSpinnerModule, 
    MatCardModule, 
    MatNativeDateModule,
    FormsModule,
    MatProgressBarModule,
    HeaderComponent,
    FooterComponent,
    ReactiveFormsModule,
    InnerHeaderComponent,
    GiftcardComponent,
    InnerFooterComponent,
    CartComponent,
    MatTooltipModule,
    ToastComponent,
    FiltersPipe,
    NgbModule
  ]
})
export class MaterialModule { }
